/* eslint-disable react/no-unescaped-entities */
import LegalLayout from "./LegalLayout";
import { COMPANY } from "./_company";

export default function Confidentialite() {
  return (
    <LegalLayout
      eyebrow="RGPD"
      title="Politique de confidentialité"
      lastUpdated={COMPANY.effectiveDate}
      intro="Vos données nourrissent BAYO — au sens propre comme au figuré. Voici exactement ce que nous collectons, pourquoi, et comment vous gardez le contrôle."
    >
      <h2>1. Responsable du traitement</h2>
      <p>
        Le responsable du traitement des données personnelles est <strong>{COMPANY.name}</strong>,{" "}
        {COMPANY.legalForm}, dont le siège est situé au {COMPANY.address}. Contact :{" "}
        <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.
      </p>

      <h2>2. Données collectées</h2>
      <p>Nous collectons uniquement les données strictement nécessaires :</p>
      <ul>
        <li>
          <strong>Création de compte</strong> : email, nom, mot de passe chiffré (bcrypt), ou
          identifiant Google si connexion via OAuth.
        </li>
        <li>
          <strong>Newsletter / ebook gratuit</strong> : email et langue préférée (FR/EN).
        </li>
        <li>
          <strong>Commandes</strong> : nom, adresse de livraison, email, contenu du panier. Les
          données de paiement (numéro de carte, CVV) sont gérées directement par Stripe et
          <em> ne transitent jamais</em> par nos serveurs.
        </li>
        <li>
          <strong>Avis et recettes</strong> : pseudonyme, contenu publié, date.
        </li>
        <li>
          <strong>Données techniques</strong> : adresse IP au moment de la connexion, en cas de
          tentative de fraude. Pas de tracking publicitaire tiers.
        </li>
      </ul>

      <h2>3. Finalités du traitement</h2>
      <ul>
        <li>Gestion de votre compte et de vos commandes (base légale : exécution du contrat).</li>
        <li>Envoi de l'ebook gratuit et de la newsletter (base légale : consentement).</li>
        <li>Programme de parrainage : un email d'envoi de l'ebook récompense au parrain (base légale : exécution du contrat).</li>
        <li>Réponse aux demandes via le formulaire de contact (base légale : intérêt légitime).</li>
        <li>Lutte contre la fraude et obligations comptables/fiscales (base légale : obligation légale).</li>
      </ul>

      <h2>4. Destinataires</h2>
      <p>
        Vos données ne sont jamais vendues. Elles sont partagées uniquement avec nos sous-traitants
        techniques, sous accord de confidentialité :
      </p>
      <ul>
        <li><strong>Stripe</strong> (Irlande) — traitement des paiements</li>
        <li><strong>Resend</strong> (États-Unis, certifié DPF) — envoi des emails transactionnels</li>
        <li><strong>{COMPANY.hosting.name}</strong> — hébergement</li>
      </ul>

      <h2>5. Durée de conservation</h2>
      <ul>
        <li>Compte utilisateur : 3 ans après la dernière connexion</li>
        <li>Données de commande (obligation comptable) : 10 ans</li>
        <li>Email newsletter : jusqu'à désinscription, ou 3 ans d'inactivité</li>
        <li>Logs techniques : 12 mois maximum</li>
      </ul>

      <h2>6. Vos droits</h2>
      <p>Conformément au RGPD (UE 2016/679), vous disposez à tout moment des droits suivants :</p>
      <ul>
        <li>Droit d'accès à vos données</li>
        <li>Droit de rectification</li>
        <li>Droit à l'effacement (« droit à l'oubli »)</li>
        <li>Droit à la limitation du traitement</li>
        <li>Droit à la portabilité</li>
        <li>Droit d'opposition</li>
        <li>Droit de retirer votre consentement à tout moment</li>
      </ul>
      <p>
        Pour exercer ces droits, écrivez à <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>{" "}
        en précisant l'objet « RGPD ». Nous répondons sous 30 jours maximum.
      </p>
      <p>
        En cas de litige, vous pouvez introduire une réclamation auprès de la CNIL :{" "}
        <a href="https://www.cnil.fr/fr/plaintes" target="_blank" rel="noopener noreferrer">
          cnil.fr/fr/plaintes
        </a>.
      </p>

      <h2>7. Cookies</h2>
      <p><strong>Cookies techniques (essentiels — sans consentement)</strong> :</p>
      <ul>
        <li><code>session_token</code> — votre session d'authentification (httpOnly, durée 7 jours)</li>
        <li><code>tropikal_cart</code> — contenu de votre panier (localStorage)</li>
        <li><code>tropikal_lang</code> — votre préférence linguistique (FR/EN)</li>
        <li><code>bayo_ref_code</code> — code de parrainage si arrivée via lien partagé (30 jours max)</li>
        <li><code>bayo_consent_v1</code> — mémorise votre choix de consentement (6 mois)</li>
      </ul>
      <p><strong>Cookies de mesure d'audience (avec votre consentement uniquement)</strong> :</p>
      <ul>
        <li>
          <code>_ga</code>, <code>_ga_*</code> — Google Analytics 4, mesure anonyme d'audience
          (visiteurs, pages vues, sources de trafic). Anonymisation IP activée. Durée : 13 mois maximum.
        </li>
      </ul>
      <p>
        Aucun cookie de mesure d'audience n'est déposé tant que vous n'avez pas cliqué sur
        « Accepter » dans le bandeau de consentement. Vous pouvez à tout moment revenir sur votre
        choix via le lien <strong>« Gérer les cookies »</strong> dans le pied de page, ou en
        vidant vos cookies depuis les paramètres de votre navigateur. Nous utilisons le
        <em>Consent Mode v2</em> de Google, qui garantit le respect de votre décision côté serveur.
      </p>

      <h2>8. Sécurité</h2>
      <p>
        Vos mots de passe sont chiffrés en base de données avec l'algorithme bcrypt. Les
        communications avec le serveur sont protégées par chiffrement TLS (HTTPS). Les tokens
        d'authentification sont stockés en cookie httpOnly et expirent automatiquement.
      </p>
    </LegalLayout>
  );
}
